import { doc, writeBatch, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";
import { rankChanges } from "./ranking";

// Saves a goal order (importance or urgency) as ranks 1, 2, 3…, in one batch, writing only the goals
// whose rank changed. Updates, never merges: a goal deleted on another device fails the batch instead of
// coming back as an empty goal. Used by the ranking steps and by dragging goals on the Goals page.
export const writeGoalRanks = (uid, view, orderedGoals) => {
  const changes = rankChanges(view, orderedGoals);
  if (!changes.length) return Promise.resolve();
  const batch = writeBatch(db);
  changes.forEach(({ id, field, rank }) => batch.update(doc(db, "users", uid, "goals", id), { [field]: rank, updatedAt: serverTimestamp() }));
  return batch.commit();
};
